import React, { memo } from 'react';
import { Col, Row } from 'antd';

import LinkComponent from '../linkComponent';

import { useRoles } from '../../helpers/roleLevelHelper';
import { useNavigate } from 'react-router-dom';

import { BRImages } from '../../assets/imgs';
import '../../assets/scss/index.scss';
import PATHS from '../../routes/paths';

const CustomFooter = () => {
  const { isAdmin, isSuperAdmin } = useRoles();

  const navigate = useNavigate();

  const footerLinks = [
    {
      title: 'Quick Links',
      links: ['Need Help?', 'Webcast', 'Video Portal', 'Audio Portal']
    },
    {
      title: 'Legal',
      links: [
        'Privacy Policy',
        'Terms of Use',
      ]
    }
  ];

  const contactDetails = [
    {
      icon: BRImages.FooterImages.FooterEmailIcon,
      text: 'bookrdecclesia@gmail.com'
    },
    {
      icon: BRImages.FooterImages.FooterContactIcon,
      text: '+( 1 )-905-304-1626'
    },
    {
      icon: BRImages.FooterImages.FooterLocationIcon,
      text: '522 Book Rd E, Ancaster, Ontario, L9G'
    }
  ];

  const handleClick = (link) => {
    switch (link) {
      case 'Need Help?':
        navigate(PATHS.HELP)
        break;

      case 'Webcast':
        navigate(PATHS.WEB_CAST_SIGN_IN)
        break;

      case 'Video Portal':
        navigate(PATHS.VIDEO_TAB)
        break;

      case 'Audio Portal':
        navigate(PATHS.AUDIO_TAB)
        break;

      case 'Privacy Policy':
        navigate(PATHS.PRIVACY_POLICY)
        break;

      case 'Terms of Use':
        navigate(PATHS.TERMS_OF_USE)
        break;

      default:
        navigate(PATHS.HOME)
        break;
    }
  }

  return (
    <div className='bookroad-footer-container w-100'>
      {!(isAdmin || isSuperAdmin) && (
        <Row className='flex justify-between footer-content'>
          <Col className='flex flex-wrap footer-links-col gap-60'>
            {footerLinks.map((section, idx) => (
              <div className='mr-82' key={idx}>
                <p className='manrope-16-bold footer-link-header mb-5'>{section.title}</p>
                <div className='footer-links-div'>
                  {section.links.map((link, index) => (
                    <LinkComponent
                      key={index}
                      title={link}
                      className='footer-links pl-0 manrope-12-medium'
                      onClick={() => handleClick(link)}
                    />
                  ))}
                </div>
              </div>
            ))}

            <div>
              <p className='manrope-16-bold footer-link-header mb-8'>Get In Touch</p>
              <div className='footer-links-div-2'>
                {contactDetails.map((contact, index) => (
                  <div className='flex items-center mb-16' key={index}>
                    <img
                      src={contact.icon}
                      alt={`${contact.text}-icon`}
                      className='footer-icon mr-5'
                    />
                    <LinkComponent
                      title={contact.text}
                      className='footer-links pl-0 manrope-12-medium pr-5'
                    />
                  </div>
                ))}
              </div>
            </div>
          </Col>
          <Col className='content-center footer-logo-container m-0'>
            <img src={BRImages.HeaderIcons.Logo} alt='logo' className='footer-logo' />
          </Col>
        </Row>
      )}

      <div className='footer-social-div'>
        <p className='text-white manrope-14-regular m-0 mb-20'>
          © {new Date().getFullYear()} Book Road Christadelphians. All Rights Reserved
        </p>
      </div>
    </div>
  );
};

export default memo(CustomFooter);
